const LaboratoryIndex = () => import("@/pages/lab/laboratory/LaboratoryIndex");
const LaboratoryDetail = () =>
  import("@/pages/lab/laboratory/LaboratoryDetail");
const LaboratorySingle = () => import("@/pages/lab/laboratory/LaboratorySingle");
const LaboratoryAdd = () => import("@/pages/lab/laboratory/LaboratoryAdd");
const LaboratoryEdit = () => import("@/pages/lab/laboratory/LaboratoryEdit");
const ServiceQuestionEdit = () =>
  import("@/pages/lab/servicequestion/ServiceQuestionEdit");

export class LaboratoryRoutes {
  constructor() {
    this.route_root = "laboratory";
    this.type_single = "Laboratory";
    this.type_plural = "Laboratories";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: `List ${this.type_plural}`,
            component: LaboratoryIndex,
            meta: { requiresAuth: true },
          },
          {
            path: "add",
            name: `Add ${this.type_single}`,
            component: LaboratoryAdd,
            meta: { requiresAuth: true },
          },
          {
            path: ":laboratory_id",
            component: LaboratorySingle,
            children: [
              {
                path: "",
                name: `View ${this.type_single}`,
                component: LaboratoryDetail,
                meta: { requiresAuth: true },
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: LaboratoryEdit,
                meta: { requiresAuth: true },
              },
              {
                path: `service-questions/update/:sample_type_id`,
                name: "Update Service Questions",
                component: ServiceQuestionEdit,
                meta: { requiresAuth: true },
              }
            ],
          },
        ],
      },
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
